module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user-faq/user-faq.component.scss
// module id = ./src/app/user-faq/user-faq.component.scss
// module chunks = main